const publicRoutes = [
  "/",
  "/home",
  "/login",
  "/register",
  "/forgot-password",
  "/send-email-forgot-password",
  "/terms",
  "/privacy-policy",
  "/conexao-empresarial",
];

export function isPublicEventPath(pathname) {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return normalizedPath === "/eventos"
    || (normalizedPath.startsWith("/eventos/") && normalizedPath !== "/eventos/inscricoes");
}

export function isPublicPath(pathname) {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

  return publicRoutes.includes(normalizedPath) || isPublicEventPath(normalizedPath);
}
